import MenuBar from './MenuBar';

export default MenuBar;